import { AlkLogger } from '@alk/core';
import {
    IForwardOrderRequest,
    IPendingOrderRequest,
    IPlaceOrderIdResponse,
    IPlaceOrderResponse,
    ISpotOrderRequest,
} from '../../interfaces';
import { inject, injectable } from 'inversify';
import { IPlaceOrder } from './place-order.interface';
import {
    IPlaceOrderAdapter,
    PLACE_ORDER_ADAPTER_SERVICE,
} from '../message-adapters/place-order-adapter';
import { ISelectedClientService, SELECTED_CLIENT_SERVICE } from '../selected-client';
import { Observable, Subject } from 'rxjs';

@injectable()
export class PlaceOrderService implements IPlaceOrder {
    @inject(PLACE_ORDER_ADAPTER_SERVICE) private readonly placeOrderAdapter: IPlaceOrderAdapter;

    @inject(SELECTED_CLIENT_SERVICE) private readonly selectedClientSrv: ISelectedClientService;

    private readonly orderRequest$ = new Subject<void>();

    sendSpotOrderRequest = async (orderRequest: ISpotOrderRequest): Promise<IPlaceOrderIdResponse> => {

        AlkLogger.debug('[PlaceOrderService#sendSpotOrderRequest] ', orderRequest);

        const currentClient = this.selectedClientSrv.getCurrent();

        const request = { ...orderRequest, ClientId: currentClient?.id };

        this.orderRequest$.next();

        return this.placeOrderAdapter.placeSpotOrder(request);
    };

    sendForwardOrderRequest = async (orderRequest: IForwardOrderRequest): Promise<IPlaceOrderResponse> => {
        AlkLogger.debug('[PlaceOrderService#sendForwardOrderRequest] ', orderRequest);

        const currentClient = this.selectedClientSrv.getCurrent();

        const request = { ...orderRequest, ClientId: currentClient.id };

        this.orderRequest$.next();

        return this.placeOrderAdapter.placeForwardOrder(request);
    };

    sendPendingOrderRequest = async (orderRequest: IPendingOrderRequest): Promise<IPlaceOrderResponse> => {
        AlkLogger.debug('[PlaceOrderService#sendPendingOrderRequest] ', orderRequest);

        const currentClient = this.selectedClientSrv.getCurrent();

        const request = { ...orderRequest, clientId: currentClient.id };

        this.orderRequest$.next();

        return this.placeOrderAdapter.placePendingOrder(request);
    };

    orderRequestObservable = (): Observable<void> => {
        return this.orderRequest$.asObservable();
    };
}
